import React from "react";
import UsersEmail from "./UsersEmail";

const ApplicantEmails=()=>{
  return <UsersEmail type="subcontractor" typeName="Subcontractors" />
}

export default ApplicantEmails;